import { render, staticRenderFns } from "./CMEditContact.vue?vue&type=template&id=42649eb4&"
import script from "./CMEditContact.vue?vue&type=script&lang=js&"
export * from "./CMEditContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42649eb4')) {
      api.createRecord('42649eb4', component.options)
    } else {
      api.reload('42649eb4', component.options)
    }
    module.hot.accept("./CMEditContact.vue?vue&type=template&id=42649eb4&", function () {
      api.rerender('42649eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMEditContact.vue"
export default component.exports